module.exports = __webpack_public_path__ + "static/media/tinkercad.081e8430.png";